import { render } from "./FieldCommon.vue?vue&type=template&id=0cb07b8f&scoped=true"
import script from "./FieldCommon.vue?vue&type=script&lang=js"
export * from "./FieldCommon.vue?vue&type=script&lang=js"

import "./FieldCommon.vue?vue&type=style&index=0&id=0cb07b8f&scoped=true&lang=css"
/* custom blocks */
import block0 from "./FieldCommon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb07b8f"]])

export default __exports__